<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import moment from 'moment'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import McButton from '@/components/McButton'
import McEmptyState from '@/components/McEmptyState'
import McRadioButton from '@/components/McRadioButton'
import McInputNumber from '@/components/McInputNumber'
import IntegrationLogHistoryModal from '@/router/views/master/fleet/components/IntegrationLogHistoryModal'
import { Helper } from '@/mixin/helper'
import { required, requiredIf, email, numeric, minLength } from 'vuelidate/lib/validators'

import {
  GET_DETAIL_EMPLOYEE,
  CREATE_EMPLOYEE,
  UPDATE_EMPLOYEE,
} from '@/services/api/master/employees'
import { GET_DEPARTMENT } from '@/services/api/setting/employee/department'
import { GET_RECRUITMENT } from '@/services/api/setting/employee/recruitment'
import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'
import { setTimeout } from 'optimism'
import { mapGetters } from 'vuex'
import datePickerLang from '@/helpers/date-picker-lang'
import LoadingSkeleton from './components/LoadingSkeleton.vue'
import ModalUploadEmployeePhoto from './components/ModalUploadEmployeePhoto.vue'
import VehicleStatusConfiguration from '@/router/views/master/rfid-facerecognition/components/VehicleStatusConfiguration.vue'
import { maxLength } from 'vuelidate/lib/validators'
import { getFaceRecognitionStatus, FACE_RECOGNITION_STATUS_LABEL } from '@/helpers/face-recognition'
import { GET_CATEGORY } from '@/services/api/setting/fleet/fleetCat'
import { GET_RFIDS } from '@/services/api/master/rfid'
import { GET_VEHICLES_BY_FEATURE_SUPPORT } from '@/services/api/master/rfid-facerecognition'

moment.locale('id')
/**
 * Starter component
 */
export default {
  page: {
    title: 'Form Karyawan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
    McEmptyState,
    LoadingSkeleton,
    McRadioButton,
    McInputNumber,
    IntegrationLogHistoryModal,
    ModalUploadEmployeePhoto,
  },
  mixins: [Helper],
  apollo: {
    employeeRecruitedAts: {
      query: GET_RECRUITMENT,
      variables() {
        return {
          filter: {
            pagination: {
              page: 1,
              show: 999999,
            },
          },
        }
      },
    },
    companyStructures: {
      query: GET_DEPARTMENT,
    },
    employee: {
      query: GET_DETAIL_EMPLOYEE,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            userId: Number(this.$route.params.id),
          },
        }
      },
      // Disable the query
      skip() {
        return this.$route.params.id === undefined
      },
      result({ data, loading }) {
        if (!loading) {
          this.initEditPage(data.employee.employee)
        }
      },
    },
  },
  data() {
    return {
      VehicleStatusConfiguration,
      FACE_RECOGNITION_STATUS_LABEL,
      id: this.$route.params.id || 0,
      selected: {
        userDocs: [],
        userWorkHistory: [],
      },
      selectedModel: {
        userDocs: [],
        userWorkHistory: [],
      },
      allSelected: {
        userDocs: false,
        userWorkHistory: false,
      },
      indeterminate: {
        userDocs: true,
        userWorkHistory: true,
      },
      employeeRecruitedAts: {
        employeeRecruitedAts: {
          data: [],
        },
      },
      companyStructures: {
        companyStructures: {
          data: [],
        },
      },
      employee: {
        employee: {},
      },
      rfidsCache: null,
      vehiclesCache: null,
      currentDate: new Date(),
      isSubmit: false,
      form: {
        employeeIdentifier: null,
        phoneNo: '',
        gender: 'M',
        email: null,
        birthplace: null,
        birthdate: null,
        maritalStatus: null,
        address: null,
        department: null,
        unit: null,
        joinOn: null,
        recruitedAt: null,
        isEmployee: true,
        isActive: true,
        inactiveOn: null,
        inactiveCause: null,
        isDriver: false,
        positionId: null,
        userDocs: [],
        userWorkHistory: [],
        photo: '',
        photoExt: '',
        photoFileName: '',
        position: null,
        isEmailVerified: null,
        isPhoneVerified: null,
        userGroup: null,
        vehicleCategory: null,
        rfid: null,
        vehicle: [],
      },
      imagePreview: require(`@/assets/images/default-image-user.png`),
      maritalStatuses: [
        { key: 'M', label: 'Kawin' },
        { key: 'S', label: 'Belum Kawin' },
        { key: 'D', label: 'Cerai Hidup' },
        { key: 'X', label: 'Cerai Mati' },
      ],
      loading: true,
      isEdit: false,
      isFileError: false,
      isActiveOpen: false,
      photoRemoved: false,
      showPhotoWarningModal: false,
      docTypeOptions: [
        'KTP',
        'KITAS',
        'NPWP',
        'PASPOR',
        'SIM A',
        'SIM A UMUM',
        'SIM B1',
        'SIM B1 UMUM',
        'SIM B2',
        'SIM B2 UMUM',
        'SIM C',
        'SIM Internasional',
        'SIO DISNAKER',
        'SIO INTERNAL',
        'SKCK',
        'BPJS Kesehatan',
        'BPJS Ketenagakerjaan',
        'ID CARD MOR IV',
        'ID CARD MOR V',
        'HSSE',
        'B3',
        'MCU',
        'DDT',
        'Commentary Drive',
        'Training Internal',
      ],
      fullObject: {
        position: {},
        maritalStatus: {},
        unit: {},
        department: {},
        employeeRecruitedAts: {},
        inactiveCause: {},
        userGroup: {},
        vehicleCategory: {},
        rfid: {},
        vehicle: [],
      },
    }
  },
  validations: {
    form: {
      email: {
        required: requiredIf(function () {
          return !this.form.phoneNo
        }),
        email,
      },
      fullname: { required },
      gender: { required },
      employeeIdentifier: { required },
      position: { required },
      inactiveOn: {
        required: requiredIf(function () {
          return this.form.isActive === false
        }),
      },
      inactiveCause: {
        required: requiredIf(function () {
          return this.form.isActive === false
        }),
      },
      phoneNo: {
        required: requiredIf(function () {
          return !this.form.email
        }),
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(17),
      },
      userDocs: {
        $each: {
          docType: {
            required: requiredIf(function () {
              return this.form.userDocs !== undefined && this.form.userDocs.length > 0
            }),
          },
          validUntil: {
            required: requiredIf(function () {
              return this.form.userDocs !== undefined && this.form.userDocs.length > 0
            }),
          },
        },
      },
      userWorkHistory: {
        $each: {
          companyName: {
            required: requiredIf(function () {
              return this.form.userWorkHistory !== undefined && this.form.userWorkHistory.length > 0
            }),
          },
          position: {
            required: requiredIf(function () {
              return this.form.userWorkHistory !== undefined && this.form.userWorkHistory.length > 0
            }),
          },
          joinedOn: {
            required: requiredIf(function () {
              return this.form.userWorkHistory !== undefined && this.form.userWorkHistory.length > 0
            }),
          },
          leftOn: {
            required: requiredIf(function () {
              return this.form.userWorkHistory !== undefined && this.form.userWorkHistory.length > 0
            }),
          },
        },
      },
    },
  },
  computed: {
    datePickerLang() {
      return datePickerLang()
    },
    dataIdentity() {
      return [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'columnDocument',
          label: this.$t('master.form.employee.identity.name'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnNomor',
          label: this.$t('master.form.employee.identity.number'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnExpired',
          label: this.$t('master.form.employee.identity.expired'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnStatus',
          label: this.$t('master.form.fleet.documentPermit.status.text'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },
    dataExperience() {
      return [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'columnCompany',
          label: this.$t('master.form.employee.jobHistory.name'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnPosition',
          label: this.$t('master.form.employee.jobHistory.position'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnEntryDate',
          label: this.$t('master.form.employee.jobHistory.entryDate'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'columnExitDate',
          label: this.$t('master.form.employee.jobHistory.exitDate'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },
    title() {
      return this.$route.params.id === undefined
        ? this.$t('master.form.employee.new')
        : this.$t('master.form.employee.change')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('menuitems.masterData.list.employee'),
          to: '/master/employee',
        },
        {
          text:
            this.$route.params.id === undefined
              ? this.$t('master.form.employee.new')
              : this.employee.employee.fullname,
        },
      ]
    },
    department() {
      return this.companyStructures.companyStructures.data.filter(function (item) {
        return item.parentId == null && !item.isPosition
      })
    },
    unit() {
      return this.companyStructures.companyStructures.data.filter(function (item) {
        return item.parentId != null && !item.isPosition
      })
    },
    position() {
      return this.companyStructures.companyStructures.data.filter(function (item) {
        return item.isPosition
      })
    },
    oldData() {
      if (this.employee.employee !== undefined) {
        let old = this.employee.employee
        let history = old.userWorkHistory || []
        let resHistory = []
        history.forEach(function (item) {
          resHistory.push({
            ...item,
            leftOn: moment(item.leftOn).format('YYYY-MM-DD'),
            joinedOn: moment(item.joinedOn).format('YYYY-MM-DD'),
            type: 'data',
          })
        })
        old.userWorkHistory = resHistory

        let docs = old.userDocs || []
        let resDocs = []
        docs.forEach(function (item) {
          resDocs.push({
            ...item,
            validUntil: item.validUntil ? moment(item.validUntil).format('YYYY-MM-DD') : null,
            type: 'data',
          })
        })
        old.userDocs = resDocs

        let formMarital = old.maritalStatus
        let marital = this.maritalStatuses.find(function (item) {
          return item.key == formMarital
        })
        old.maritalStatus = marital || null

        let recruitedAt = old.recruitedAt
        let recruit = this.employeeRecruitedAts.employeeRecruitedAts.data.find(function (item) {
          return item.text == recruitedAt
        })
        old.recruitedAt = recruit || null

        return old
      }

      return null
    },
    docTypeUnSelected() {
      let selectedDoc = this.form.userDocs.map((item) => item.docType)
      selectedDoc = selectedDoc.filter((item) => item != null)

      let options = this.docTypeOptions.filter((item) => {
        return !selectedDoc.includes(item)
      })

      return options
    },
    yearShow() {
      let year = this.form.birthdate
      if (year !== null) {
        let now = moment()
        let pick = moment(year).format('YYYY-MM-DD')
        let diff = moment(now).diff(pick, 'years')

        return year + ` (${diff})`
      }
      return null
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),

    resourcefulQuery() {
      return {
        positions: (opts) => {
          let result = {}
          let positions = this.companyStructures.companyStructures.data.filter(function (item) {
            return item.isPosition
          })
          if (opts.search)
            positions = positions.filter((item) => this.isContains(opts.search, item.name))

          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: positions,
            },
          }

          return result
        },
        maritalStatuses: (opts) => {
          let result = {}
          let maritalStatuses = this.maritalStatuses
          if (opts.search)
            maritalStatuses = maritalStatuses.filter((item) =>
              this.isContains(opts.search, item.label)
            )

          result = {
            metadata: {
              total_page: 1,
              total_count: 4,
              page: 1,
            },
            data: {
              paginated_result: maritalStatuses,
            },
          }

          return result
        },
        departments: (opts) => {
          let result = {}
          let departments = this.department
          if (opts.search)
            departments = departments.filter((item) => this.isContains(opts.search, item.name))

          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: departments,
            },
          }

          return result
        },
        units: (opts) => {
          let result = {}
          let units = this.unit
          if (opts.search) units = units.filter((item) => this.isContains(opts.search, item.name))
          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: units,
            },
          }

          return result
        },
        employeeRecruitedAts: (opts) => {
          let result = {}
          let employeeRecruitedAts = this.employeeRecruitedAts.employeeRecruitedAts.data
          if (opts.search)
            employeeRecruitedAts = employeeRecruitedAts.filter((item) =>
              this.isContains(opts.search, item.name)
            )

          result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: employeeRecruitedAts,
            },
          }

          return result
        },
        inactiveCauses: (opts) => {
          let causes = [
            { key: 'PHK', label: 'PHK' },
            { key: 'Mengundurkan Diri', label: 'Mengundurkan Diri' },
            { key: 'Keluar Tanpa Alasan', label: 'Keluar Tanpa Alasan' },
          ]
          if (opts.search) causes = causes.filter((item) => this.isContains(opts.search, item.key))
          let result = {}

          result = {
            metadata: {
              total_page: 1,
              total_count: 3,
              page: 1,
            },
            data: {
              paginated_result: causes,
            },
          }

          return result
        },
        userGroups: async (opts) => {
          let result = {}
          const filter = {
            pagination: {
              page: opts?.page,
              show: opts?.limit,
            },
            search: opts?.search,
            showSuperAdmin: false,
            showSuperUserOperational: true,
          }

          const res = await this.$apollo.query({
            query: GET_USER_GROUP,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
              },
            },
          })

          const ugroups = res.data.ugroups.ugroups

          result = {
            metadata: {
              total_count: ugroups.pagination.total,
              page: ugroups.pagination.page,
            },
            data: {
              paginated_result: ugroups.data,
            },
          }

          return result
        },
        vehicleCategory: async (opts) => {
          try {
            let result = {}
            const filter = {
              pagination: {
                page: opts?.page || 1,
                show: opts?.limit || 10,
              },
              search: opts?.search || null,
            }

            // Logic only for MGM
            if (this.getCustomFeatureMGM.company_id.includes(this.getCompanyId())) {
              return {
                metadata: {
                  total_page: 1,
                  total_count: 0,
                  page: 1,
                },
                data: {
                  paginated_result: this.getCustomFeatureMGM.filtered_vehicle_category
                    .map((category) => ({ category }))
                    .filter((item) => this.isContains(opts.search, item.category)),
                },
              }
            }

            const res = await this.$apollo.query({
              query: GET_CATEGORY,
              fetchPolicy: 'no-cache',
              variables: {
                filter: {
                  ...filter,
                },
              },
            })

            if (res?.data?.vehicleCategories?.vehicleCategories) {
              const vehicleCategories = res.data.vehicleCategories.vehicleCategories

              result = {
                metadata: {
                  total_page: Math.ceil(
                    vehicleCategories.pagination.total / vehicleCategories.pagination.show
                  ),
                  total_count: vehicleCategories.pagination.total,
                  page: vehicleCategories.pagination.page,
                },
                data: {
                  paginated_result: vehicleCategories.data || [],
                },
              }
            } else {
              result = {
                metadata: {
                  total_page: 1,
                  total_count: 0,
                  page: 1,
                },
                data: {
                  paginated_result: [],
                },
              }
            }

            return result
          } catch (error) {
            console.error('Error fetching vehicle categories:', error)

            return {
              metadata: {
                total_page: 1,
                total_count: 0,
                page: 1,
              },
              data: {
                paginated_result: [],
              },
            }
          }
        },
        rfid: async (opts) => {
          let result = {}

          if (this.rfidsCache === null) {
            const res = await this.$apollo.query({
              query: GET_RFIDS,
              fetchPolicy: 'network-only',
              variables: {
                filter: {
                  pagination: {
                    page: 1,
                    show: 9999,
                  },
                  search: null,
                },
              },
            })
            this.rfidsCache = res.data.getRfids.getRfids.data
          }

          let rfids = [...this.rfidsCache]

          if (opts.search) {
            rfids = rfids.filter((item) => this.isContains(opts.search, item.rfid))
          }

          result = {
            metadata: {
              total_count: rfids.length,
              page: 1,
            },
            data: {
              paginated_result: rfids,
            },
          }

          return result
        },
        vehicle: async (opts) => {
          let result = {}
          const feature = 'IDENTIFICATION'
          try {
            const res = await this.$apollo.query({
              query: GET_VEHICLES_BY_FEATURE_SUPPORT,
              fetchPolicy: 'no-cache',
              variables: {
                filter: {
                  pagination: {
                    page: opts?.page || 1,
                    show: opts?.limit || 10,
                  },
                  search: opts?.search || null,
                  feature: feature,
                  withUnsupportedVehicles: true,
                },
              },
            })

            const data = res.data?.vehiclesByFeatureSupport?.vehiclesByFeatureSupport

            if (!data || !data.pagination) {
              result = {
                metadata: {
                  total_page: 1,
                  total_count: 0,
                  count: 0,
                  page: opts?.page || 1,
                },
                data: {
                  paginated_result: [],
                },
              }
            } else {
              result = {
                metadata: {
                  total_page: Math.ceil(data.pagination.total / data.pagination.show),
                  total_count: data.pagination.total,
                  count: data.pagination.total,
                  page: opts?.page || 1,
                },
                data: {
                  paginated_result: data?.data ? [...data.data] : [],
                },
              }
            }
          } catch (e) {
            console.error('Error fetching vehicle options:', e)
            result = {
              metadata: {
                total_count: 0,
                page: 1,
              },
              data: {
                paginated_result: [],
              },
            }
          }

          return result
        },
      }
    },
    userGroupTableFields() {
      return [
        {
          key: 'name',
          label: this.$t('master.form.employee.userGroup'),
          isSortable: false,
          isRedirectable: true,
        },
      ]
    },
    hasUserGroupAccess() {
      return (
        this.hasAccessAll([
          'tms-user-group:create',
          'tms-user-group:delete',
          'tms-user-group:read',
          'tms-user-group:update',
        ]) && this.isSuperUser()
      )
    },
    getCustomFeatureMGM() {
      return this.getFeatureFlagValue('customFeature.mgm')
    },
    hasDriverCompatibility() {
      return this.hasAccessAll([
        'driver-compatibility:read',
        'driver-compatibility:create',
        'driver-compatibility:update',
      ])
    },
    hasScopeRfidAndFaceRecognition() {
      return this.hasAccessAll(['d10a-default-rfid&fr:read', 'd10a-default-rfid&fr:update'])
    },
  },
  created() {
    for (let i = 0; i < this.form.userDocs.length; i++) {
      this.selectedModel.userDocs.push(false)
    }

    this.$watch('selected.userDocs', (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.userDocs = false
        this.allSelected.userDocs = false
      } else if (newValue.length == this.form.userDocs.length) {
        this.indeterminate.userDocs = false
        this.allSelected.userDocs = true
      } else {
        this.indeterminate.userDocs = true
        this.allSelected.userDocs = false
      }
    })
  },
  methods: {
    initEditPage(data) {
      this.isEdit = true
      this.loading = true
      this.employee.employee = data
      this.form.employeeIdentifier = data.employeeIdentifier
      this.form.fullname = data.fullname
      this.form.phoneNo = data.phoneNo ?? ''
      this.form.gender = data.gender
      this.form.email = data.email
      this.form.birthplace = data.birthplace
      this.form.birthdate = data.birthdate
      this.form.address = data.address
      this.form.isEmployee = data.isEmployee
      this.form.isActive = data.isActive
      this.form.isDriver = data.isDriver
      this.form.position = data.position?.name
      this.fullObject.position = data.position
      this.form.inactiveOn = data.inactiveOn
      this.form.inactiveCause = data.inactiveCause
      this.form.isEmailVerified = data.isEmailVerified
      this.form.isPhoneVerified = data.isPhoneVerified
      this.fullObject.inactiveCause = { key: data.inactiveCause, label: data.inactiveCause }
      this.form.userGroup = data.groups[0]?.id
      this.fullObject.userGroup = data.groups[0]
      this.form.rfid = data.identification?.methods?.rfid
      this.fullObject.rfid = data.identification?.methods?.rfid
        ? { rfid: data.identification.methods.rfid }
        : {}
      this.form.vehicle = data.identification?.vehicles?.map((v) => v.vehicleId) || []
      this.fullObject.vehicle =
        data.identification?.vehicles?.map((v) => ({
          id: v.vehicleId,
          vehicleId: v.vehicleId,
          licensePlate: v.licensePlate,
        })) || []
      this.changeStatus(data.isActive)

      this.photoRemoved = false
      if (data.photograph != null && data.photograph != '') {
        this.imagePreview = data.photograph
        this.form.photo = data.photograph
        const urlParts = data.photograph.split('/')
        const fileName = urlParts[urlParts.length - 1] || 'images.jpg'
        this.form.photoFileName = fileName

        // Extract extension to ensure it is sent back during save
        const fileNameParts = fileName.split('.')
        if (fileNameParts.length > 1) {
          this.form.photoExt = fileNameParts.pop()
        }
      }

      let formMarital = data.maritalStatus
      let marital = this.maritalStatuses.find(function (item) {
        return item.key == formMarital
      })

      this.form.maritalStatus = marital ? marital.key : null
      this.fullObject.maritalStatus = marital || null
      this.form.positionId = data.position ? data.position?.structureId : null

      if (this.form.position != null) {
        this.positionChanged()
      }

      let recruitedAt = data.recruitedAt
      let recruit = this.employeeRecruitedAts.employeeRecruitedAts.data.find(function (item) {
        return item.text == recruitedAt
      })
      this.form.recruitedAt = recruit ? recruit.text : null
      this.fullObject.employeeRecruitedAts = recruit || null
      this.form.joinOn = data.joinOn

      let history = data.userWorkHistory || []
      let resHistory = []
      history.forEach(function (item) {
        resHistory.push({
          ...item,
          leftOn: moment(item.leftOn).format('YYYY-MM-DD'),
          joinedOn: moment(item.joinedOn).format('YYYY-MM-DD'),
          disabledLeftDate: function (date) {
            let joinedOn = new Date(item.joinedOn)
            return date < joinedOn.setDate(joinedOn.getDate() - 1)
          },
          type: 'data',
        })
      })
      this.form.userWorkHistory = resHistory

      let docs = data.userDocs || []
      let resDocs = []
      docs.forEach(function (item) {
        resDocs.push({
          ...item,
          validUntil: item.validUntil ? moment(item.validUntil).format('YYYY-MM-DD') : null,
          type: 'data',
        })
      })
      this.form.userDocs = resDocs
      this.loading = false

      if (this.hasDriverCompatibility) {
        this.fullObject.vehicleCategory = data.vehicleCategories?.[0]
          ? { category: data.vehicleCategories[0] }
          : null
        this.form.vehicleCategory = data.vehicleCategories?.[0] ?? null
      }
    },
    submitForm() {
      // stop here if form is invalid
      this.$v.$touch()
    },
    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.form[param].length; i++) {
          this.selected[param].push(i)
          this.selectedModel[param].push(true)
        }
      } else {
        for (let i = 0; i < this.form[param].length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },
    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.index)
      } else {
        let myIndex = this.selected[param].indexOf(data.index)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },
    add(param, obj) {
      this.form[param].push(obj)
    },
    checkStatus(index) {
      const today = new Date()
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      const date =
        today.getFullYear() + '-' + zeroPad(today.getMonth() + 1, 2) + '-' + today.getDate()
      if (date >= this.form[index].expired) {
        this.form[index].status = 'expired'
      } else {
        let range = this.getDatesInRange(date, this.form[index].expired).length
        if (range <= 30) {
          this.form[index].status = 'near'
        } else {
          this.form[index].status = 'active'
        }
      }
    },
    getDatesInRange(startDate, endDate) {
      startDate = new Date(startDate)
      endDate = new Date(endDate)
      const date = new Date(startDate.getTime())

      const dates = []

      while (date <= endDate) {
        dates.push(new Date(date))
        date.setDate(date.getDate() + 1)
      }

      return dates
    },
    toDelete(param) {
      this.selected[param].sort()
      this.selected[param].reverse()
      this.selected[param].forEach((row) => {
        this.$delete(this.form[param], row)
      })
      this.selected[param] = []
      this.selectedModel[param] = []

      this.indeterminate[param] = false
      this.allSelected[param] = false
      for (let i = 0; i < this.form[param].length; i++) {
        this.selectedModel[param].push(false)
      }
    },
    checkEmpty() {
      let isEmpty = true
      let forms = this.form
      let excepts = ['status', 'gender', 'isEmployee', 'isActive']
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != null && forms[key] != '') {
          if (typeof forms[key] !== 'object') {
            if (!excepts.includes(key)) {
              isEmpty = false
            }
          } else {
            if (!excepts.includes(key)) {
              if (Array.isArray(forms[key])) {
                if (forms[key].length > 0) {
                  isEmpty = false
                }
              } else {
                Object.keys(forms[key]).forEach(function (subKey) {
                  if (forms[key][subKey] != null && forms[key][subKey] != '') {
                    isEmpty = false
                  }
                })
              }
            }
          }
        }
      })

      return isEmpty
    },
    checkChanged() {
      let isChanged = false
      let forms = this.form
      let formOld = this.oldData
      let excepts = ['department', 'unit', 'photoExt', 'positionId', 'photo']
      Object.keys(this.form).forEach(function (key) {
        if (!excepts.includes(key)) {
          if (forms[key] != formOld[key]) {
            if (key == 'userDocs' || key == 'userWorkHistory') {
              if (JSON.stringify(forms[key]) != JSON.stringify(formOld[key])) {
                isChanged = true
              }
            } else {
              isChanged = true
            }
          }
        }
      })

      return isChanged
    },
    toCancel() {
      let isEmpty = this.checkEmpty()
      if (this.$route.params.id) {
        isEmpty = !this.checkChanged()
      }

      if (isEmpty) {
        this.$router.push('/master/employee')
      } else {
        Swal.fire({
          title: this.$t('global.alert.text.cancel'),
          text: this.$t('global.alert.text.confirmCancel'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('global.action.yes'),
          cancelButtonText: this.$t('global.action.no'),
        }).then((result) => {
          if (result.value) {
            this.$router.push('/master/employee')
          }
        })
      }
    },

    positionChanged(position = this.fullObject.position) {
      this.fullObject.position = position || {}

      const unitId = position?.parentId ?? position?.unitId
      const unit =
        this.unit.find(
          (item) =>
            item.structureId != null &&
            unitId != null &&
            String(item.structureId) === String(unitId)
        ) ||
        (position?.unitId != null && position?.unitName
          ? {
              structureId: position.unitId,
              parentId: position.departmentId ?? null,
              name: position.unitName,
              isPosition: false,
            }
          : null)

      const departmentId = unit?.parentId ?? position?.departmentId
      const department =
        this.department.find(
          (item) =>
            item.structureId != null &&
            departmentId != null &&
            String(item.structureId) === String(departmentId)
        ) ||
        (position?.departmentId != null && position?.departmentName
          ? {
              structureId: position.departmentId,
              parentId: null,
              name: position.departmentName,
              isPosition: false,
            }
          : null)

      this.form.unit = unit?.name ?? null
      this.fullObject.unit = unit
      this.form.department = department?.name ?? null
      this.fullObject.department = department

      if (this.form.position !== 'Driver') {
        this.form.vehicleCategory = null
      }
    },

    validate() {
      // Checking validation
      this.$v.$touch()
      return !this.$v.form.$error
    },

    toSave() {
      this.$refs.formRef.showErrors()

      let validate = this.validate()
      if (!validate) {
        if (this.$v.form.userDocs.$error) {
          this.$mcToast.error(this.$t('master.form.employee.identity.docsReq'))
        }
        return
      }

      const isDriverAndNoIdentity =
        this.isEdit &&
        this.form.position === 'Driver' &&
        this.hasScopeRfidAndFaceRecognition &&
        !this.form.photo &&
        !this.form.rfid

      if (isDriverAndNoIdentity) {
        this.showPhotoWarningModal = true
        return
      }

      this.proceedToSave()
    },

    handleApplyPhotoWarning() {
      this.showPhotoWarningModal = false
      this.form.vehicle = []
      this.fullObject.vehicle = []
      this.proceedToSave()
    },

    proceedToSave() {
      this.isSubmit = true
      let userObject = {}
      if (this.$route.params.id !== undefined) {
        userObject = { userId: parseInt(this.id) }
      }

      let userDocs = []
      this.form.userDocs.forEach(function (item) {
        userDocs.push({
          docType: item.docType,
          docNumber: item.docNumber || null,
          validUntil: item.validUntil || null,
          ...userObject,
        })
      })

      let userWorkHistory = []
      this.form.userWorkHistory.forEach(function (item) {
        userWorkHistory.push({
          companyName: item.companyName,
          position: item.position,
          joinedOn: item.joinedOn,
          leftOn: item.leftOn,
          ...userObject,
        })
      })

      let uDocsObject = {}
      if (userDocs.length > 0) {
        uDocsObject = { userDocs: userDocs }
      } else {
        uDocsObject = { userDocs: [] }
      }

      let uHistoryObject = {}
      if (userWorkHistory.length > 0) {
        uHistoryObject = { userWorkHistory: userWorkHistory }
      } else {
        uHistoryObject = { userWorkHistory: [] }
      }

      let photoObject = {}
      if (this.photoRemoved) {
        photoObject = {
          photo: null,
          photoExt: null,
        }
      } else if (
        this.form.photo != '' &&
        this.form.photo != null &&
        !this.form.photo.startsWith('http')
      ) {
        photoObject = {
          photo: this.form.photo,
          photoExt: this.form.photoExt,
        }
      }

      let isDriver = {}
      if (this.form.position) {
        if (
          this.fullObject.position.name.toLowerCase() == 'pengemudi' ||
          this.fullObject.position.name.toLowerCase() == 'driver'
        ) {
          isDriver = {
            isDriver: true,
          }
        } else {
          isDriver = {
            isDriver: false,
          }
        }
      }

      if (this.form.email) {
        this.form.email = this.form.email.toLowerCase()
      }

      let input = {
        birthdate: this.form.birthdate,
        birthplace: this.form.birthplace,
        fullname: this.form.fullname,
        gender: this.form.gender,
        maritalStatus: this.form.maritalStatus ? this.fullObject.maritalStatus.key : null,
        address: this.form.address,
        email: this.form.email,
        employeeIdentifier: this.form.employeeIdentifier,
        phoneNo: this.form.phoneNo,
        isEmployee: this.form.isEmployee,
        recruitedAt: this.form.recruitedAt || null,
        joinOn: this.form.joinOn,
        isActive: this.form.isActive,
        inactiveOn: this.form.inactiveOn,
        inactiveCause: this.form.inactiveCause,
        positionId: this.form.position ? this.fullObject.position.structureId : null,
        group: Number(this.form.userGroup),
        vehicleCategories: this.hasDriverCompatibility
          ? this.form.vehicleCategory
            ? [this.form.vehicleCategory]
            : []
          : undefined,
        identification: {
          rfid: this.form.rfid === '' ? null : this.form.rfid,
          vehicleIds: this.form.vehicle ? this.form.vehicle : [],
        },
        ...uDocsObject,
        ...uHistoryObject,
        ...photoObject,
        ...isDriver,
      }

      if (this.$route.params.id !== undefined) {
        let oldDocs = []
        if (this.oldData.userDocs !== undefined) {
          this.oldData.userDocs.forEach(function (item) {
            oldDocs.push({
              docType: item.docType,
              docNumber: item.docNumber,
              validUntil: item.validUntil,
              ...userObject,
            })
          })
        }

        let oldHistory = []
        if (this.oldData.userWorkHistory !== undefined) {
          this.oldData.userWorkHistory.forEach(function (item) {
            oldHistory.push({
              companyName: item.companyName,
              position: item.position,
              joinedOn: item.joinedOn,
              leftOn: item.leftOn,
              ...userObject,
            })
          })
        }

        let uOldDocs = {}
        if (oldDocs.length > 0) {
          uOldDocs = { userDocs: oldDocs }
        } else {
          uOldDocs = { userDocs: [] }
        }

        let uOldHistory = {}
        if (oldHistory.length > 0) {
          uOldHistory = { userWorkHistory: oldHistory }
        } else {
          uOldHistory = { userWorkHistory: [] }
        }

        let oldData = {
          birthdate: this.oldData.birthdate,
          birthplace: this.oldData.birthplace,
          fullname: this.oldData.fullname,
          gender: this.oldData.gender,
          maritalStatus: this.oldData.maritalStatus ? this.oldData.maritalStatus.key : null,
          address: this.oldData.address,
          email: this.oldData.email,
          employeeIdentifier: this.oldData.employeeIdentifier,
          phoneNo: this.oldData.phoneNo,
          isEmployee: this.oldData.isEmployee,
          recruitedAt: this.oldData.recruitedAt ? this.oldData.recruitedAt.text : null,
          joinOn: this.oldData.joinOn,
          isActive: this.oldData.isActive,
          inactiveOn: this.oldData.inactiveOn,
          inactiveCause: this.oldData.inactiveCause,
          positionId: this.oldData.position ? this.oldData.position.structureId : null,
          group: this.oldData.groups ? this.oldData.groups[0]?.id : null,
          vehicleCategories: this.hasDriverCompatibility
            ? this.oldData.vehicleCategories
              ? this.oldData.vehicleCategories
              : []
            : undefined,
          identification: {
            rfid:
              this.oldData.identification?.methods?.rfid === ''
                ? null
                : this.oldData.identification?.methods?.rfid,
            vehicleIds: this.oldData.identification?.vehicles?.map((v) => v.vehicleId) || [],
          },
          photograph: this.oldData.photograph,
          ...uOldDocs,
          ...uOldHistory,
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_EMPLOYEE,
            variables: {
              input: {
                userId: parseInt(this.id),
                oldData: oldData,
                newData: input,
              },
            },
          })
          .then((response) => {
            if (response.data.updateEmployee.isSuccessful) {
              this.$apollo.queries.employee.refetch()
              this.$mcToast.success(this.$t('liveView.text.dataSaved'))

              setTimeout(() => {
                this.$router.push({ name: 'Master Employee' })
              }, 1000)
            } else {
              let errMsg = response.data.updateEmployee.message
              if (errMsg == 'Error: "email was registered"') {
                this.$mcToast.error(this.$t('master.form.employee.emailExisted'))
              } else if (errMsg == 'Error: "employee identifier was registered"') {
                this.$mcToast.error(this.$t('master.form.employee.nipExisted'))
              } else {
                this.$mcToast.warning(response.data.updateEmployee.message)
              }
              this.isSubmit = false
            }
          })
      } else {
        this.$apollo
          .mutate({
            mutation: CREATE_EMPLOYEE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.createEmployee.isSuccessful) {
              this.$mcToast.success(this.$t('liveView.text.dataSaved'))

              this.id = response.data.createEmployee.employee.userId
              setTimeout(() => {
                this.$router.push({
                  name: 'Master Employee Detail',
                  params: { id: this.id },
                })
              }, 1000)
            } else {
              let errMsg = response.data.createEmployee.message
              if (errMsg == 'Error: "email was registered"') {
                this.$mcToast.error(this.$t('master.form.employee.emailExisted'))
              } else if (errMsg == 'Error: "employee identifier was registered"') {
                this.$mcToast.error(this.$t('master.form.employee.nipExisted'))
              } else {
                this.$mcToast.warning(response.data.createEmployee.message)
              }
            }
          })
        this.isSubmit = false
      }
    },

    onDocsClick(data, i) {
      data.type = 'form'
      this.form.userDocs[i].type = 'form'
    },

    onHistoryClick(data, i) {
      data.type = 'form'
      this.form.userWorkHistory[i].type = 'form'
    },

    getIdentityStatus(data) {
      if (data == '' || data == null) return null
      let now = moment(new Date())
      let date = moment(data)
      let diff = now.diff(date, 'days') * -1

      if (diff >= 30) {
        return 'Berlaku'
      } else if (diff < 30 && diff >= 0) {
        return 'Akan Kedaluwarsa'
      } else if (diff <= 0) {
        return 'Kedaluwarsa'
      }
    },
    changeStatus(checked) {
      this.form.isActive = checked
      if (checked) {
        this.isActiveOpen = false
      } else {
        this.isActiveOpen = true
      }
    },

    isEmployee(value) {
      this.form.isEmployee = value
    },

    onFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      this.$refs.modalUploadEmployeePhoto.show(this.oldData || {}, file)
      e.target.value = ''
    },

    handleUploadSuccess(data) {
      this.imagePreview = data.previewUrl
      this.form.photo = data.photo
      this.form.photoExt = data.photoExt
      this.form.photoFileName = data.fileName
      this.photoRemoved = false
      this.isFileError = false
    },

    removePhoto() {
      this.imagePreview = require(`@/assets/images/default-image-user.png`)
      this.form.photo = ''
      this.form.photoExt = ''
      this.form.photoFileName = ''
      this.photoRemoved = true
      this.isFileError = false
    },

    disabledRange: function (date) {
      return date >= new Date()
    },

    getFaceRecognitionStatus() {
      const hasPhoto =
        (this.form.photo != null && this.form.photo !== '') ||
        (this.employee?.employee?.photograph != null && this.employee?.employee?.photograph !== '')
      const faceStatuses = (this.employee?.employee?.identification?.vehicles || [])
        .map((v) => v?.methodStatuses?.faceRecognition)
        .filter((s) => s != null)
      return getFaceRecognitionStatus({ hasPhoto, faceStatuses })
    },

    changeJoinDateWorkHistory(index) {
      let self = this
      this.form.userWorkHistory[index].disabledLeftDate = function (date) {
        if (!self.form.userWorkHistory[index].joinedOn) return null

        let joinedOn = new Date(self.form.userWorkHistory[index].joinedOn)
        return date < joinedOn.setDate(joinedOn.getDate() - 1)
      }
    },

    isNumber(event) {
      event = event ? event : window.event
      let charCode = event.which ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            v-if="
              form.isDriver &&
              hasAccessAll([
                'users:update',
                'd5a-default-mdkaryawan:read',
                'last_summary_trip_driver:read',
                'summary_trip_driver:read',
              ])
            "
            variant="secondary"
            class="mx-2"
            icon="icon-outline_file-text"
            :text="$t('master.form.employee.travelHistory')"
            @click="
              $router.push({
                name: 'Riwayat Perjalanan Pengemudi',
                params: { id: $route.params.id },
              })
            "
          />
          <McButton
            v-if="hasAccessAll(['webhook-log-event-md:read', 'webhook-event-du1-mde1:read'])"
            class="ms-2"
            variant="secondary"
            text="Riwayat Integrasi"
            icon="icon-large icon-outline_file-text"
            @click="$bvModal.show('integration-log-modal-value-help')"
          />
          <McButton
            variant="secondary"
            class="mx-2"
            icon="icon-fill_close"
            :text="$t('global.cancel')"
            @click="toCancel"
          />

          <McButton
            variant="primary"
            type="button"
            :disabled="isFileError || isSubmit"
            icon="icon-outline_save"
            :text="$t('global.save')"
            @click="toSave"
          />
        </div>
      </div>
    </div>

    <b-skeleton-wrapper :loading="$route.params.id && loading">
      <template #loading>
        <LoadingSkeleton />
      </template>

      <div class="mc-form">
        <h4 class="card-title">Biodata</h4>
        <FormulateForm ref="formRef" v-model="form">
          <b-card>
            <b-row>
              <b-col sm="12" md="6">
                <b-row>
                  <b-col md="3">
                    <div class="d-flex justify-content-center mb-2">
                      <img
                        :src="imagePreview"
                        alt
                        class="avatar-lg rounded-circle img-thumbnail"
                        style="object-fit: cover"
                      />
                      <span class="validation-icon" v-if="hasScopeRfidAndFaceRecognition">
                        <i
                          v-if="
                            $route.params.id !== undefined &&
                            getFaceRecognitionStatus() === FACE_RECOGNITION_STATUS_LABEL.VALID
                          "
                          class="icon-fill_checkmark-circle green-500"
                          v-b-tooltip.hover
                          :title="$t('rfidAndFacerecognition.photo.success')"
                        ></i>
                        <i
                          v-else-if="
                            $route.params.id !== undefined &&
                            getFaceRecognitionStatus() === FACE_RECOGNITION_STATUS_LABEL.PENDING
                          "
                          class="mc-fa icon-fill_clock yellow-500"
                          v-b-tooltip.hover
                          :title="$t('rfidAndFacerecognition.photo.pending')"
                        ></i>
                        <i
                          v-else-if="
                            $route.params.id !== undefined &&
                            getFaceRecognitionStatus() === FACE_RECOGNITION_STATUS_LABEL.INVALID
                          "
                          class="mc-fa icon-fill_alert-circle red-500"
                          v-b-tooltip.hover
                          :title="$t('rfidAndFacerecognition.photo.failed')"
                        ></i>
                        <i
                          v-else-if="
                            $route.params.id !== undefined &&
                            getFaceRecognitionStatus() === FACE_RECOGNITION_STATUS_LABEL.WITH_PHOTO
                          "
                          class="icon-fill_checkmark-circle green-500"
                          v-b-tooltip.hover
                          :title="$t('rfidAndFacerecognition.photo.success')"
                        ></i>
                        <i v-else-if="$route.params.id !== undefined"></i>
                      </span>
                    </div>
                  </b-col>
                  <b-col md="9">
                    <div class="mc-input-info">
                      <FormulateInput
                        id="formFile"
                        type="image-input"
                        :isFileError="isFileError"
                        :onFileChange="onFileChange"
                        :onCustomClick="() => $refs.modalUploadEmployeePhoto.show(oldData || {})"
                        :validationText="$t('master.form.employee.photoProfileLimit2')"
                        :fileName="form.photoFileName"
                        :onRemove="removePhoto"
                      >
                        <template #label>
                          <div class="d-flex justify-content-between align-items-center">
                            <label class="formulate-input-label">
                              {{ $t('master.form.employee.profilePicture') }}
                            </label>
                          </div>
                        </template>
                      </FormulateInput>
                      <i
                        v-if="
                          $route.params.id !== undefined &&
                          form.position === 'Driver' &&
                          hasScopeRfidAndFaceRecognition
                        "
                      >
                        <i class="text-danger">* </i>
                        <span class="text-muted">{{
                          $t('rfidAndFacerecognition.upload.faceRecognitionWarning')
                        }}</span>
                      </i>
                      <i class="custom-input-help-text input-md" v-else>
                        <i class="text-danger">* </i>
                        <span class="text-muted"
                          >Format (.JPG / .PNG),
                          {{ $t('master.form.employee.photoProfileLimit1') }}</span
                        >
                      </i>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="3">
                <FormulateInput
                  id="name"
                  validation="required"
                  name="fullname"
                  :placeholder="$t('master.form.employee.fullName')"
                  :validation-messages="{
                    required: $t('master.form.employee.fullNameRequired'),
                  }"
                  :help="true"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="formulate-input-label">
                        {{ $t('master.form.employee.fullName') }}
                      </label>
                    </div>
                  </template>
                </FormulateInput>
              </b-col>
              <b-col sm="12" md="3">
                <FormulateInput
                  id="employeeIdentifier"
                  validation="required"
                  name="employeeIdentifier"
                  :placeholder="$t('master.form.employee.nip')"
                  :validation-messages="{
                    required: $t('master.form.employee.nipRequired'),
                  }"
                  :help="true"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="formulate-input-label">
                        {{ $t('master.form.employee.nip') }}
                      </label>
                    </div>
                  </template>
                </FormulateInput>
              </b-col>
              <b-col sm="12" md="3">
                <b-form-group class="mb-3 mt-1">
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('master.form.employee.gender') }}<i class="text-danger">*</i>
                      </label>
                    </div>
                  </template>

                  <div class="d-flex flex-row">
                    <McRadioButton
                      id="maleGender"
                      v-model="form.gender"
                      name="gender"
                      :initialValue="'M'"
                      class="me-3"
                      :label="$t('global.object.male')"
                    />
                    <McRadioButton
                      id="femaleGender"
                      v-model="form.gender"
                      name="gender"
                      :initialValue="'F'"
                      :label="$t('global.object.female')"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="birthplace"
                    name="birthplace"
                    :placeholder="$t('master.form.employee.birthPlace')"
                    :label="$t('master.form.employee.birthPlace')"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="birthdate"
                    v-model="form.birthdate"
                    name="birthdate"
                    type="date-picker"
                    :disabled-date="disabledRange"
                    :placeholder="$t('master.form.employee.birthDate')"
                    :label="$t('master.form.employee.birthDate')"
                    format="DD MMM YYYY"
                    value-type="YYYY-MM-DD"
                    :confirm="true"
                    :confirm-text="$t('global.action.apply')"
                    :first-day-of-week="1"
                    :lang="datePickerLang"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="maritalStatus"
                    v-model="form.maritalStatus"
                    name="maritalStatus"
                    type="select-resourceful-v2"
                    trackBy="key"
                    :placeholder="$t('master.form.employee.maritalStatus')"
                    :label="$t('master.form.employee.maritalStatus')"
                    :optionsGetter="resourcefulQuery.maritalStatuses"
                    :taggable="false"
                    :multiple="false"
                    :optionLabelFn="({ item }) => item.label"
                    :fullObject="fullObject.maritalStatus"
                    @update:fullObject="($event) => (fullObject.maritalStatus = $event)"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <b-form-group class="mb-2 mt-1">
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('master.form.employee.phoneNumber') }}
                      </label>
                    </div>
                  </template>
                  <div class="d-flex justify-content-between align-items-end gap-1">
                    <div class="w-100">
                      <mc-input-number
                        id="phone_number"
                        v-model="form.phoneNo"
                        name="phoneNo"
                        :disabled="form.isPhoneVerified"
                        :invalidMsg="$t('master.form.employee.phoneFormat')"
                        :placeholder="$t('master.form.employee.phoneNumber')"
                        @onChange="(val) => (form.phoneNo = val)"
                        @onValid="(val) => (isValidPhone = val)"
                      />
                      <div>
                        <small class="text-muted fst-italic">
                          {{ $t('master.form.employee.emailOrPhoneRequired') }}
                        </small>
                      </div>
                      <small v-if="$v.form.phoneNo.$error" class="text-danger">
                        <span v-if="!$v.form.phoneNo.minLength">{{
                          $t('master.form.employee.phoneMin')
                        }}</span>
                        <span v-else-if="!$v.form.phoneNo.maxLength">{{
                          $t('master.form.employee.phoneMax')
                        }}</span>
                        <span v-else-if="!$v.form.phoneNo.isValidPhone">{{
                          $t('master.form.employee.phoneInvalid')
                        }}</span>
                      </small>
                    </div>
                    <i
                      v-if="form.isPhoneVerified"
                      class="icon-fill_checkmark-circle font-size-16 align-middle mb-3"
                    >
                    </i>
                  </div>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3 d-flex justify-content-between align-items-end gap-1">
                  <FormulateInput
                    id="email"
                    name="email"
                    class="w-100"
                    :validation="(form.phoneNo ? 'optional' : 'required') + '|email'"
                    :placeholder="$t('master.form.customer.email')"
                    :disabled="form.isEmailVerified"
                    :validation-messages="{
                      required: '',
                      email: $t('master.form.employee.emailFormat'),
                    }"
                  >
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="formulate-input-label">
                          {{ $t('master.form.customer.email') }}
                        </label>
                      </div>
                    </template>
                    <template #help>
                      <span class="text-muted small fst-italic">
                        {{ $t('master.form.employee.emailOrPhoneRequired') }}
                      </span>
                    </template>
                  </FormulateInput>
                  <i
                    v-if="form.isEmailVerified"
                    class="icon-fill_checkmark-circle green-500 font-size-16 align-middle mb-3 ms-1"
                  >
                  </i>
                </div>
              </b-col>
              <b-col sm="12" md="6">
                <div class="mb-3">
                  <FormulateInput
                    id="address"
                    name="address"
                    type="text"
                    :placeholder="$t('master.form.employee.address')"
                    :label="$t('master.form.employee.address')"
                  />
                </div>
              </b-col>
            </b-row>
          </b-card>

          <h4 class="card-title">
            {{ $t('master.form.employee.job') }}
          </h4>

          <b-card>
            <b-row>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="position"
                    v-model="form.position"
                    name="position"
                    type="select-resourceful-v2"
                    trackBy="name"
                    :placeholder="$t('master.form.employee.position')"
                    validation="required"
                    :validation-messages="{
                      required: $t('master.form.employee.positionRequired'),
                    }"
                    :help="true"
                    :optionsGetter="resourcefulQuery.positions"
                    :taggable="false"
                    :multiple="false"
                    :optionLabelFn="({ item }) => item.name"
                    :fullObject="fullObject.position"
                    @update:fullObject="positionChanged"
                  >
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="formulate-input-label">
                          {{ $t('master.form.employee.position') }}
                        </label>
                      </div>
                    </template>
                  </FormulateInput>
                </div>
              </b-col>

              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="department"
                    v-model="form.department"
                    name="department"
                    type="select-resourceful-v2"
                    trackBy="name"
                    :label="$t('master.form.employee.department')"
                    :placeholder="$t('master.form.employee.department')"
                    :optionsGetter="resourcefulQuery.departments"
                    :taggable="false"
                    :multiple="false"
                    :optionLabelFn="({ item }) => item.name"
                    :fullObject="fullObject.department"
                    :disabled="true"
                    @update:fullObject="($event) => (fullObject.department = $event)"
                  />
                </div>
              </b-col>
              <b-col sm="12" md="3">
                <div class="mb-3">
                  <FormulateInput
                    id="unit"
                    v-model="form.unit"
                    name="unit"
                    type="select-resourceful-v2"
                    trackBy="name"
                    :label="$t('master.form.employee.unit')"
                    :placeholder="$t('master.form.employee.unit')"
                    :optionsGetter="resourcefulQuery.units"
                    :taggable="false"
                    :multiple="false"
                    :optionLabelFn="({ item }) => item.name"
                    :fullObject="fullObject.unit"
                    :disabled="true"
                    @update:fullObject="($event) => (fullObject.unit = $event)"
                  />
                </div>
              </b-col>
              <b-col
                v-if="form.position === 'Driver' && hasScopeRfidAndFaceRecognition"
                sm="12"
                md="3"
              >
                <div class="mb-3">
                  <FormulateInput
                    id="vehicle"
                    v-model="form.vehicle"
                    name="vehicle"
                    type="select-resourceful-v3"
                    :placeholder="`${$t('global.form.select')} ${$t(
                      'master.form.employee.inVehicle'
                    )}`"
                    :label="$t('master.form.employee.inVehicle')"
                    :optionsGetter="resourcefulQuery.vehicle"
                    :optionLabelFn="({ item }) => item.licensePlate"
                    :fullObject="fullObject.vehicle"
                    selectedLabel="licensePlate"
                    trackBy="id"
                    :taggable="false"
                    :multiple="true"
                    :hasClose="false"
                    :visibleTagCount="2"
                    :hasOptionMeta="true"
                    :metaRightComponent="VehicleStatusConfiguration"
                    :showSelectionCount="true"
                    :max="30"
                    @update:fullObject="($event) => (fullObject.vehicle = $event)"
                  />
                </div>
              </b-col>
              <b-col
                v-if="form.position === 'Driver' && hasScopeRfidAndFaceRecognition"
                sm="12"
                md="3"
              >
                <div class="mb-3">
                  <FormulateInput
                    id="rfid"
                    v-model="form.rfid"
                    name="rfid"
                    type="select-resourceful-v2"
                    trackBy="rfid"
                    label="RFID"
                    placeholder="RFID"
                    :optionsGetter="resourcefulQuery.rfid"
                    :taggable="false"
                    :multiple="false"
                    :optionLabelFn="({ item }) => item.rfid"
                    :fullObject="fullObject.rfid"
                    @update:fullObject="($event) => (fullObject.rfid = $event)"
                    :help="true"
                  />
                </div>
              </b-col>
              <b-col v-if="hasUserGroupAccess" sm="12" md="3">
                <FormulateInput
                  name="userGroup"
                  :label="$t('master.form.employee.userGroup')"
                  :placeholder="`${$t('global.form.select')} ${$t(
                    'master.form.employee.userGroup'
                  )}`"
                  :multiple="false"
                  type="value-help-v2"
                  trackBy="id"
                  :displayedBy="'name'"
                  :listGetter="resourcefulQuery.userGroups"
                  :tableFields="userGroupTableFields"
                  :fullObject="fullObject.userGroup"
                  validation="required"
                  :validation-messages="{
                    required: $t('master.form.employee.userGroupRequired'),
                  }"
                  :help="true"
                />
              </b-col>
              <b-col v-if="hasDriverCompatibility" sm="12" md="3">
                <FormulateInput
                  id="vehicleCategory"
                  v-model="form.vehicleCategory"
                  name="vehicleCategory"
                  type="select-resourceful-v2"
                  trackBy="category"
                  :taggable="false"
                  :multiple="false"
                  :label="$t('master.form.employee.vehicleCategory')"
                  :placeholder="`${$t('global.form.select')} ${$t(
                    'master.form.employee.vehicleCategory'
                  )}`"
                  :optionLabelFn="({ item }) => item.category"
                  :optionsGetter="resourcefulQuery.vehicleCategory"
                  :fullObject="fullObject.vehicleCategory"
                  :disabled="form.position !== 'Driver'"
                  @update:fullObject="($event) => (fullObject.vehicleCategory = $event)"
                />
              </b-col>
              <b-col sm="12" md="3">
                <b-form-group class="mb-3 mt-1">
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>
                        {{ $t('master.form.employee.jobStatus') }}
                      </label>
                    </div>
                  </template>
                  <div class="d-flex flex-row">
                    <McRadioButton
                      id="active"
                      v-model="form.isActive"
                      name="isActive"
                      class="me-3"
                      :label="$t('global.active')"
                      :initialValue="true"
                      :disabled="cannotDelete(parseInt(id))"
                      @change="changeStatus(true)"
                    />
                    <McRadioButton
                      id="inActive"
                      v-model="form.isActive"
                      name="isActive"
                      :label="$t('global.nonActive')"
                      :initialValue="false"
                      :disabled="cannotDelete(parseInt(id))"
                      @change="changeStatus(false)"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <div class="mt-3">
                  <div class="form-check-right form-switch">
                    <input
                      id="SwitchCheckSizemd"
                      v-b-toggle.info-work
                      class="form-check-input ms-2"
                      type="checkbox"
                    />
                    <label class="" for="SwitchCheckSizemd">
                      {{ $t('global.object.otherInfo') }}
                    </label>
                  </div>
                </div>
              </b-col>
              <b-collapse
                id="inactive-employee"
                v-model="isActiveOpen"
                accordion="inactive-accordion"
                role="tabpanel"
                class="mt-3"
              >
                <b-row>
                  <b-col sm="12" md="6">
                    <div class="mb-3">
                      <FormulateInput
                        id="inactiveOn"
                        v-model="form.inactiveOn"
                        name="inactiveOn"
                        type="date-picker"
                        :disabled-date="disabledRange"
                        :placeholder="$t('master.form.employee.inactiveOn')"
                        :label="$t('master.form.employee.inactiveOn')"
                        :validation="form.isActive ? 'optional' : 'required'"
                        :validation-messages="{
                          required: $t('master.form.employee.inactiveOnRequired'),
                        }"
                        format="YYYY-MM-DD"
                        value-type="YYYY-MM-DD"
                        :confirm="true"
                        :confirm-text="$t('global.action.apply')"
                        :first-day-of-week="1"
                        :lang="datePickerLang"
                        :help="true"
                      >
                      </FormulateInput>
                    </div>
                  </b-col>
                  <b-col sm="12" md="6">
                    <div class="mb-3">
                      <FormulateInput
                        id="inactiveCause"
                        v-model="form.inactiveCause"
                        name="inactiveCause"
                        type="select-resourceful-v2"
                        trackBy="key"
                        :placeholder="$t('master.form.employee.inactiveReason')"
                        :label="$t('master.form.employee.inactiveReason')"
                        :validation="form.isActive ? 'optional' : 'required'"
                        :validation-messages="{
                          required: $t('master.form.employee.inactiveReasonRequired'),
                        }"
                        :optionsGetter="resourcefulQuery.inactiveCauses"
                        :taggable="false"
                        :multiple="false"
                        :optionLabelFn="({ item }) => item.label"
                        :fullObject="fullObject.inactiveCause"
                        @update:fullObject="($event) => (fullObject.inactiveCause = $event)"
                        :help="true"
                      >
                      </FormulateInput>
                    </div>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-row>

            <b-collapse id="info-work" accordion="my-accordion" role="tabpanel">
              <b-row>
                <b-col sm="12" md="3">
                  <div class="mb-3">
                    <FormulateInput
                      id="joinOn"
                      v-model="form.joinOn"
                      name="joinOn"
                      type="date-picker"
                      :placeholder="$t('master.form.employee.joinOn')"
                      :label="$t('master.form.employee.joinOn')"
                      format="YYYY-MM-DD"
                      value-type="YYYY-MM-DD"
                      :confirm="true"
                      :confirm-text="$t('global.action.apply')"
                      :first-day-of-week="1"
                      :lang="datePickerLang"
                    />
                  </div>
                </b-col>
                <b-col sm="12" md="3">
                  <div class="mb-3">
                    <FormulateInput
                      id="recruitedAt"
                      v-model="form.recruitedAt"
                      name="recruitedAt"
                      type="select-resourceful-v2"
                      trackBy="text"
                      :placeholder="$t('master.form.employee.recruitedAt')"
                      :label="$t('master.form.employee.recruitedAt')"
                      :optionsGetter="resourcefulQuery.employeeRecruitedAts"
                      :taggable="false"
                      :multiple="false"
                      :optionLabelFn="({ item }) => item.text"
                      :fullObject="fullObject.employeeRecruitedAts"
                      @update:fullObject="($event) => (fullObject.employeeRecruitedAts = $event)"
                    />
                  </div>
                </b-col>
                <b-col sm="12" md="3">
                  <div class="mb-3">
                    <b-form-group class="mb-3 mt-1">
                      <template #label>
                        <div class="d-flex justify-content-between align-items-center">
                          <label>
                            {{ $t('master.form.employee.isEmployee') }}
                          </label>
                        </div>
                      </template>

                      <div class="d-flex flex-row">
                        <McRadioButton
                          id="isEmployee"
                          v-model="form.isEmployee"
                          name="isEmployee"
                          :initialValue="true"
                          class="me-3"
                          :label="$t('maintenance.order.filter.internal')"
                          @change="isEmployee(true)"
                        />
                        <McRadioButton
                          id="isEmployee1"
                          v-model="form.isEmployee"
                          name="isEmployee"
                          :initialValue="false"
                          :label="$t('maintenance.order.filter.external')"
                          @change="isEmployee(false)"
                        />
                      </div>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </FormulateForm>

        <div class="clearfix mb-3">
          <div class="float-start">
            <h4 class="card-title">
              {{ $t('master.form.employee.identity.title') }}
            </h4>
          </div>

          <div class="float-end">
            <McButton
              v-if="selected.userDocs.length"
              variant="secondary-red"
              class="mx-2"
              icon="icon-outline_trash"
              :text="$t('global.delete')"
              @click="toDelete('userDocs')"
            />
            <McButton
              v-if="$route.params.id"
              variant="primary"
              icon="icon-outline_plus"
              :text="$t('global.addField')"
              @click="
                add('userDocs', {
                  type: 'form',
                  validUntil: '',
                })
              "
            />
          </div>
        </div>

        <b-card>
          <div v-if="!$route.params.id">
            <McEmptyState
              :title="$t('master.form.employee.emptystate.identityTitle')"
              :desc="$t('master.form.employee.emptystate.identityDesc')"
              :hasButton="false"
            />
          </div>
          <div v-else class="table-responsive my-3 border border-1">
            <b-table
              small
              show-empty
              :empty-text="$t('global.emptyTable')"
              :empty-filtered-text="$t('global.emptyFilteredTable')"
              :fields="dataIdentity"
              :items="form.userDocs"
              responsive="sm"
              class="datatables mc-table-fleetdoc"
              @row-clicked="onDocsClick"
            >
              <template #head(check)>
                <div class="form-check">
                  <b-form-checkbox
                    v-model="allSelected.userDocs"
                    :indeterminate="indeterminate.userDocs"
                    :value="true"
                    :unchecked-value="false"
                    @change="toggleAll($event, 'userDocs')"
                  />
                </div>
              </template>

              <template #cell(check)="data">
                <div class="form-check">
                  <b-form-checkbox
                    v-model="selectedModel.userDocs[data.index]"
                    :value="true"
                    :unchecked-value="false"
                    @change="checkTable($event, data, 'userDocs')"
                  />
                </div>
              </template>

              <template #cell(columnDocument)="data">
                <b-form-group v-if="data.item.type == 'form'">
                  <multiselect
                    v-model="form.userDocs[data.index].docType"
                    class="style-chooser"
                    :class="{
                      'is-invalid': $v.form.userDocs.$each[data.index].docType.$error,
                    }"
                    :placeholder="$t('master.form.employee.identity.name')"
                    :options="docTypeUnSelected"
                    openDirection="top"
                  />
                  <div
                    v-if="$v.form.userDocs.$each[data.index].docType.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.form.userDocs.$each[data.index].docType.required">
                      {{ $t('master.form.employee.identity.nameReq') }}
                    </span>
                  </div>
                </b-form-group>
                <span v-else>
                  {{ data.item.docType }}
                </span>
              </template>

              <template #cell(columnNomor)="data">
                <b-form-input
                  v-if="data.item.type == 'form'"
                  v-model="form.userDocs[data.index].docNumber"
                  :placeholder="$t('master.form.employee.identity.number')"
                />
                <span v-else>
                  {{ data.item.docNumber }}
                </span>
              </template>

              <template #cell(columnExpired)="data">
                <b-form-group v-if="data.item.type == 'form'">
                  <date-picker
                    v-model="form.userDocs[data.index].validUntil"
                    format="DD MMM YYYY"
                    value-type="YYYY-MM-DD"
                    :placeholder="$t('master.form.employee.identity.expired')"
                    :first-day-of-week="1"
                    :lang="datePickerLang"
                    :class="{
                      'is-invalid': $v.form.userDocs.$each[data.index].validUntil.$error,
                    }"
                  />
                  <div
                    v-if="$v.form.userDocs.$each[data.index].docType.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.form.userDocs.$each[data.index].docType.required">
                      {{ $t('master.form.employee.identity.expiredReq') }}
                    </span>
                  </div>
                </b-form-group>
                <span v-else>
                  {{ data.item.validUntil ? momentDateShortMonth(data.item.validUntil) : '' }}
                </span>
              </template>

              <template #cell(columnStatus)="data">
                <div>
                  <span
                    v-if="getIdentityStatus(data.item.validUntil) == 'Kedaluwarsa'"
                    class="mc-status mc-status--red"
                  >
                    {{ $t('master.form.employee.expired') }}
                  </span>
                  <span
                    v-else-if="getIdentityStatus(data.item.validUntil) == 'Akan Kedaluwarsa'"
                    class="mc-status mc-status--yellow"
                  >
                    {{ $t('master.form.employee.willExpired') }}
                  </span>
                  <span
                    v-else-if="getIdentityStatus(data.item.validUntil) == 'Berlaku'"
                    class="mc-status mc-status--green"
                  >
                    {{ $t('master.form.employee.valid') }}
                  </span>
                </div>
              </template>
            </b-table>
          </div>
        </b-card>

        <div class="clearfix mb-3">
          <div class="float-start">
            <h4 class="card-title">
              {{ $t('master.form.employee.jobHistory.title') }}
            </h4>
          </div>

          <div class="float-end">
            <McButton
              v-if="selected.userWorkHistory.length"
              variant="outline-danger"
              class="mx-2"
              icon="bx bx-trash-alt"
              :text="$t('global.delete')"
              @click="toDelete('userWorkHistory')"
            />
            <McButton
              v-if="$route.params.id"
              variant="primary"
              icon="mc-fa icon-outline_plus"
              :text="$t('global.addField')"
              @click="
                add('userWorkHistory', {
                  type: 'form',
                })
              "
            />
          </div>
        </div>

        <b-card>
          <div v-if="!$route.params.id">
            <McEmptyState
              :title="$t('master.form.employee.emptystate.jobHistoryTitle')"
              :desc="$t('master.form.employee.emptystate.identityDesc')"
              :hasButton="false"
            />
          </div>

          <div v-else class="table-responsive my-3 border border-1">
            <b-table
              small
              show-empty
              :empty-text="$t('global.emptyTable')"
              :empty-filtered-text="$t('global.emptyFilteredTable')"
              :fields="dataExperience"
              :items="form.userWorkHistory"
              responsive="sm"
              class="datatables"
              @row-clicked="onHistoryClick"
            >
              <template #head(check)>
                <div class="form-check">
                  <b-form-checkbox
                    v-model="allSelected.userWorkHistory"
                    :indeterminate="indeterminate.userWorkHistory"
                    :value="true"
                    :unchecked-value="false"
                    @change="toggleAll($event, 'userWorkHistory')"
                  />
                </div>
              </template>

              <template #cell(check)="data">
                <div class="form-check">
                  <b-form-checkbox
                    v-model="selectedModel.userWorkHistory[data.index]"
                    :value="true"
                    :unchecked-value="false"
                    @change="checkTable($event, data, 'userWorkHistory')"
                  />
                </div>
              </template>

              <template #cell(columnCompany)="data">
                <b-form-input
                  v-if="data.item.type == 'form'"
                  v-model="form.userWorkHistory[data.index].companyName"
                  :class="{
                    'is-invalid': $v.form.userWorkHistory.$each[data.index].companyName.$error,
                  }"
                  :placeholder="$t('master.form.employee.jobHistory.name')"
                />
                <span v-else>
                  {{ data.item.companyName }}
                </span>
              </template>

              <template #cell(columnPosition)="data">
                <b-form-input
                  v-if="data.item.type == 'form'"
                  v-model="form.userWorkHistory[data.index].position"
                  :placeholder="$t('master.form.employee.jobHistory.position')"
                  :class="{
                    'is-invalid': $v.form.userWorkHistory.$each[data.index].position.$error,
                  }"
                />
                <span v-else>
                  {{ data.item.position }}
                </span>
              </template>

              <template #cell(columnEntryDate)="data">
                <date-picker
                  v-if="data.item.type == 'form'"
                  v-model="form.userWorkHistory[data.index].joinedOn"
                  :class="{
                    'is-invalid': $v.form.userWorkHistory.$each[data.index].joinedOn.$error,
                  }"
                  format="DD MMM YYYY"
                  value-type="YYYY-MM-DD"
                  :placeholder="$t('master.form.employee.jobHistory.entryDate')"
                  :first-day-of-week="1"
                  :lang="datePickerLang"
                  @input="changeJoinDateWorkHistory(data.index)"
                />
                <span v-else>
                  {{ momentDateShortMonth(data.item.joinedOn) }}
                </span>
              </template>

              <template #cell(columnExitDate)="data">
                <date-picker
                  v-if="data.item.type == 'form'"
                  v-model="form.userWorkHistory[data.index].leftOn"
                  :class="{
                    'is-invalid': $v.form.userWorkHistory.$each[data.index].leftOn.$error,
                  }"
                  format="DD MMM YYYY"
                  value-type="YYYY-MM-DD"
                  :placeholder="$t('master.form.employee.jobHistory.exitDate')"
                  :first-day-of-week="1"
                  :lang="datePickerLang"
                  :disabled="
                    form.userWorkHistory[data.index].joinedOn == null ||
                    form.userWorkHistory[data.index].joinedOn === undefined
                  "
                  :disabled-date="form.userWorkHistory[data.index].disabledLeftDate"
                />

                <span v-else>
                  {{ momentDateShortMonth(data.item.leftOn) }}
                </span>
              </template>
            </b-table>
          </div>
        </b-card>
      </div>
    </b-skeleton-wrapper>
    <IntegrationLogHistoryModal
      v-if="hasAccessAll(['webhook-log-event-md:read', 'webhook-event-du1-mde1:read'])"
      module="md-employee"
      :identifier="$route.params.id"
    />
    <ModalUploadEmployeePhoto ref="modalUploadEmployeePhoto" @success="handleUploadSuccess" />

    <b-modal
      id="photo-warning-modal"
      v-model="showPhotoWarningModal"
      :title="$t('setting.list.webhook.alert')"
      header-bg-variant="primary"
      header-text-variant="white"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="d-flex align-items-start">
        <div>{{ $t('rfidAndFacerecognition.confirmationDeleteIdentity') }}</div>
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-end gap-2">
          <McButton
            variant="secondary"
            :text="$t('global.cancel')"
            @click="showPhotoWarningModal = false"
          />
          <McButton
            variant="primary"
            :text="$t('global.action.apply')"
            @click="handleApplyPhotoWarning"
          />
        </div>
      </template>
    </b-modal>
  </Layout>
</template>
<style lang="scss" scoped>
.validation-icon {
  font-size: 20px;
  position: absolute;
  bottom: 15px;
  right: 60px;

  i {
    border-radius: 100%;
    background-color: $white;
  }
}
</style>
